import DeveloperView from "@/components/developer/DeveloperView.vue";
import QuitDeveloperView from "@/components/developer/QuitDeveloperView.vue";
import ErrorView from "@/components/ErrorView.vue";
import InvalidOperationErrorView from "@/components/InvalidOperationErrorView.vue";
import LoginView from "@/components/authentication/LoginView.vue";
import RedirectView from "@/components/RedirectView.vue";
import WarningView from "@/components/WarningView.vue";
import ConfirmView from "@/components/ConfirmView.vue";
import { ExtendedRouteConfig } from "./ExtendedRouteConfig";
import { Query } from "./Query";
import { Dispatcher } from "./Dispatcher";
import { AbstractRoutesFactory } from "./AbstractRoutesFactory";

export class RoutesFactory extends AbstractRoutesFactory<Query, Dispatcher<Query>> {
  constructor(dispatcher: Dispatcher<Query>) {
    super(dispatcher);
  }

  create(): ExtendedRouteConfig[] {
    return [
      {
        path: "/Login",
        name: "ログイン",
        component: LoginView,
        meta: { isLogin: true },
        props: r => this.toProps(r, q => ({
          redirect: q.redirect,
          userCode: q.userCode,
          departmentCode: q.departmentCode,
          hostName: q.hostName,
          orderUserCode: q.orderUserCode,
          attendingUserCode: q.attendingUserCode,
          shouldSelectDepartmentManually: q.shouldSelectDepartment,
          departmentGroupCode: q.departmentGroupCode,
          referenceableDepartmentGroupCodes: q.referenceableDepartmentGroupCodes,
          defaultAccountCode: q.defaultAccountCode,
        })),
      },
      {
        path: "/Redirect",
        name: "リダイレクト",
        component: RedirectView,
        props: r => this.toProps(r, q => ({
          redirect: q.redirect,
          userCode: q.userCode,
          departmentCode: q.departmentCode,
          hostName: q.hostName,
          orderUserCode: q.orderUserCode,
          attendingUserCode: q.attendingUserCode,
          departmentGroupCode: q.departmentGroupCode,
          referenceableDepartmentGroupCodes: q.referenceableDepartmentGroupCodes,
        })),
      },
      {
        path: "/Error",
        name: "エラー",
        component: ErrorView,
        meta: {
          isAlwaysRestorable: true,
        },
        props: r => this.toProps(r, q => ({
          url: q.url,
          title: q.title,
          message: q.message,
          timeoutAsMsec: q.timeoutAsMsec,
        })),
      },
      {
        path: "/Warning",
        name: "ワーニング",
        component: WarningView,
        meta: {
          isAlwaysRestorable: true,
        },
        props: r => this.toProps(r, q => ({
          url: q.url,
          title: q.title,
          message: q.message,
          timeoutAsMsec: q.timeoutAsMsec,
        })),
      },
      {
        path: "/Confirm",
        name: "確認",
        component: ConfirmView,
        meta: {
          isAlwaysRestorable: true,
        },
        props: r => this.toProps(r, q => ({
          title: q.title,
          message: q.message,
          actionButtonName: q.actionButtonName,
          cancelButtonName: q.cancelButtonName,
          destination: q.destination,
        })),
      },
      {
        path: "/BackDoor",
        name: "開発者モード",
        component: DeveloperView,
        meta: {
          requiresAuth: true,
          isAlwaysRestorable: true,
        },
      },
      {
        path: "/BackDoor/Close",
        name: "開発者モード終了",
        component: QuitDeveloperView,
        meta: {
          isAlwaysRestorable: true,
        },
      },
      {
        path: "*",
        name: "不正操作エラー",
        component: InvalidOperationErrorView,
        meta: {
          isAlwaysRestorable: true,
        },
      },
    ];
  }
}
